<div class="detalle-solicitud-container">
  <div style="font-size: 24px; font-weight: bold">
    Detalle de Solicitud de Reembolso
  </div>
  <br />
  <div
    class="informacion-solicitud"
    *ngIf="!user?.esColaborador; else TemplateColaborador"
  >
    <h3 class="section-title">Información de la Solicitud</h3>

    <!-- Primera fila -->
    <div class="info-row">
      <div class="info-field">
        <span class="field-label">Identificador:</span>
        <span class="field-value">{{ solicitud?.id || "N/A" }}</span>
      </div>

      <div class="info-field">
        <span class="field-label">Estatus:</span>
        <span class="field-value">
          <div
            class="estatus-container-detalle"
            [class.texto-negro]="shouldUseBlackText(solicitud?.estatusNombre)"
            [style.background-color]="getEstatusColor(solicitud?.estatusNombre)"
          >
            <img
              [src]="getEstatusIcon(solicitud?.estatusNombre)"
              class="estatus-icon"
              alt="Estatus icon"
            />
            <span class="estatus-text">{{
              solicitud?.estatusNombre || "N/A"
            }}</span>
          </div>
        </span>
      </div>

      <div class="info-field">
        <span class="field-label">Colaborador:</span>
        <span class="field-value">{{ getColaboradorNombre() }}</span>
      </div>
    </div>

    <!-- Segunda fila -->
    <div class="info-row">

      <div class="info-field">
        <span class="field-label">Fecha de Solicitud:</span>
        <span class="field-value">{{
          (solicitud?.fechaSolicitud | date : "dd/MM/yyyy") || "N/A"
        }}</span>
      </div>

      <div class="info-field" *ngIf="solicitud?.fechaPago && solicitud?.fechaPago!.length > 0">
        <span class="field-label">Fecha de Aprobación:</span>
        <span class="field-value">{{
          (solicitud?.fechaPago | date : "dd/MM/yyyy") || "N/A"
        }}</span>
      </div>

      <div class="info-field" *ngIf="solicitud?.montoTotalAutorizado">
        <span class="field-label">Monto Autorizado:</span>
        <span class="field-value monto-aprobado-value">
          {{ solicitud?.montoTotalAutorizado | currency : "MXN" : "symbol" : "1.2-2" }}
        </span>
      </div>
    </div>
  </div>
<nz-spin [nzSpinning]="loading"></nz-spin>
  <ng-template #TemplateColaborador>
    <div class="informacion-solicitud">
      <h3 class="section-title">Información de la Solicitud</h3>

      <!-- Primera fila -->
      <div class="info-row">
        <div class="info-field">
          <span class="field-label">Estatus:</span>
          <span class="field-value">
            <div
              class="estatus-container-detalle"
              [class.texto-negro]="shouldUseBlackText(solicitud?.estatusNombre)"
              [style.background-color]="
                getEstatusColor(solicitud?.estatusNombre)
              "
            >
              <img
                [src]="getEstatusIcon(solicitud?.estatusNombre)"
                class="estatus-icon"
                alt="Estatus icon"
              />
              <span class="estatus-text">{{
                solicitud?.estatusNombre || "N/A"
              }}</span>
            </div>
          </span>
        </div>


      <div class="info-field">
        <span class="field-label">Fecha de Solicitud:</span>
        <span class="field-value">{{
          (solicitud?.fechaSolicitud | date : "dd/MM/yyyy") || "N/A"
        }}</span>
      </div>
      </div>
      <div class="info-row">

        <div class="info-field" *ngIf="solicitud?.montoTotalAutorizado">
          <span class="field-label">Monto Autorizado:</span>
          <span class="field-value monto-aprobado-value">
            {{
              solicitud?.montoTotalAutorizado
                | currency : "MXN" : "symbol" : "1.2-2"
            }}
          </span>
        </div>

      <div class="info-field" *ngIf="solicitud?.fechaPago && solicitud?.fechaPago!.length > 0">
        <span class="field-label">Fecha de Aprobación:</span>
        <span class="field-value">{{
          (solicitud?.fechaPago | date : "dd/MM/yyyy") || "N/A"
        }}</span>
      </div>

      </div>
    </div>
  </ng-template>

  <hr class="divider" />
  <nz-spin [nzSpinning]="loadingArchivos">
  <div class="archivos-section">
    <h3 class="archivos-titulo" *ngIf="detalle && detalle.length > 0">Archivos</h3>
    <nz-alert
      *ngIf="alertStatus.success"
      nzType="success"
      nzMessage="Archivos validados correctamente"
      nzShowIcon
    ></nz-alert>
    <!-- nzDescription="{{ solicitud?.comentariosAutorizacion}}" -->
    <nz-alert
      *ngIf="alertStatus.info"
      nzType="info"
      nzMessage="Archivos validados parcialmente - Revisión pendiente"
      nzShowIcon
    ></nz-alert>
    <nz-alert
      *ngIf="alertStatus.error"
      nzType="error"
      nzMessage="Archivos rechazados - No válidos"
      nzShowIcon
    ></nz-alert>
    <div class="archivos-scroll-container" *ngIf="detalle && detalle.length > 0">
      <ng-container *ngFor="let archivo of detalle">
      <div 
        class="archivo-item" 
        [class.archivo-rechazado]="hasRejectionReason(archivo)"
        (click)="verArchivo(archivo.id!, archivo.nombreArchivoPdf!, null)"
        nz-popover
        [nzPopoverContent]="hasRejectionReason(archivo) ? getRejectionReason(archivo) : ''"
        nzPopoverPlacement="top"
        [nzPopoverOverlayClassName]="hasRejectionReason(archivo) ? 'rejection-popover' : ''"
      >
        <img src="assets/images/pdf.png" alt="PDF" class="archivo-icon" />
        <span class="archivo-nombre">{{ archivo.nombreArchivoPdf || 'N/A'}}</span>
      </div>
      <div 
        class="archivo-item" 
        [class.archivo-rechazado]="hasRejectionReason(archivo)"
        (click)="verArchivo(archivo.id!, archivo.nombreArchivoXml!, null )"
        nz-popover
        [nzPopoverContent]="hasRejectionReason(archivo) ? getRejectionReason(archivo) : ''"
        nzPopoverPlacement="top"
        [nzPopoverOverlayClassName]="hasRejectionReason(archivo) ? 'rejection-popover' : ''"
      >
        <img src="assets/images/xml.png" alt="XML" class="archivo-icon" />
        <span class="archivo-nombre">{{ archivo.nombreArchivoXml || 'N/A'}}</span>
      </div>
      </ng-container>
  </div>
  <hr class="divider" *ngIf="detalle && detalle.length > 0"/>

  <nz-descriptions nzBordered nzTitle="Observaciones" nzSize="default">
  </nz-descriptions>
  <br />
  <div class="informacion-solicitud">
    {{ solicitud?.comentariosAutorizacion}}
  </div>
</div>
</nz-spin>
